import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PersonalPackageListDialogComponent } from './shared/dialog/personalPackageListDialog.component';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { VerifierComponent } from './verifier/verifier.component';
import { CandidateComponent } from './candidate/candidate.component';
import { ContactComponent } from './contact/contact.component';
import { FooterComponent } from './footer/footer.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SuccessDialogComponent } from './shared/dialog/successDialog.component';
import { PackageListDialogComponent } from './shared/dialog/packageDialog.component';
import { PDFService } from './shared/services/pdf.service';
import { UserExistConfirmationDialogComponent } from './shared/dialog/userExistConfirmationDialog.component';
import {
  MatAutocompleteModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatCardModule, MatDialogModule, MatButtonModule,
  MatSortModule,
  MatTableModule,
  MatPaginatorModule,
  MatProgressSpinnerModule
} from '@angular/material';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { LoginService } from './shared/services/login.service';
import { ProfileService } from './shared/services/profile.service';
import { HttpModule } from '@angular/http';
import { CommonService } from './shared/services/commom.service';
import { HomeModule } from './home/home.module';
import { EditEmployeeListDialogComponent } from './shared/dialog/editEmployeeList.component';
import { UploadFileDialogComponent } from './shared/dialog/uploadFile.component';
import { EditVerifierListDialogComponent } from './shared/dialog/editVerifierList.component';
import { BackgroundCheckService } from '././get-my-background-check/background-shared/services/backgroundCheck.service';
import { RouterModule } from '@angular/router';
import { SelectedServiceDialogComponent } from './shared/dialog/selectedServiceDialog.component';
import { BackgroundDashboardService } from './shared/services/backgroundDashboard.service';
import { TurnAroundTimeDialogComponent } from './shared/dialog/turnaroundTimeDialog.component';
import { ImpressEmployerDialogComponent } from './shared/dialog/impressEmployerDialog.component';
import { ConfirmationAddServiceDialogComponent } from './shared/dialog/confirmationAddService.component';
import { ViewProgressDialogComponent } from './shared/dialog/viewProgressDialog.component';
import { AddAddressComponent } from './shared/dialog/addAddress.component';
import { SignatureDialogComponent } from './shared/dialog/signatureConfirmation.component';
import { ViewMoreAddressDialogComponent } from './shared/dialog/viewMoreAddressDialog.component';
import { AppHttpInterceptor } from './shared/services/TokenInterceptor.service';
import { FeeApprovalModelComponent } from './shared/dialog/feeApprovalModel.component';
// import { UserIdleModule } from 'angular-user-idle';


export const createTranslateLoader = (http: HttpClient) => {
  /* for development
  return new TranslateHttpLoader(
      http,
      '/start-angular/SB-Admin-BS4-Angular-6/master/dist/assets/i18n/',
      '.json'
  ); */
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};

@NgModule({
  declarations: [
    AppComponent,
    SuccessDialogComponent,
    EditEmployeeListDialogComponent,
    UploadFileDialogComponent,
    EditVerifierListDialogComponent,
    PackageListDialogComponent,
    PersonalPackageListDialogComponent,
    SelectedServiceDialogComponent,
    TurnAroundTimeDialogComponent,
    ImpressEmployerDialogComponent,
    ConfirmationAddServiceDialogComponent,
    ViewProgressDialogComponent,
    AddAddressComponent,
    SignatureDialogComponent,
    ViewMoreAddressDialogComponent,
    UserExistConfirmationDialogComponent,
    FeeApprovalModelComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    MatSelectModule,
    AppRoutingModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    HttpModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    HttpClientModule,
    MatProgressSpinnerModule
    // UserIdleModule.forRoot({ idle: 600, timeout: 300, ping: 120 })
  ],
  providers: [LoginService, ProfileService, CommonService, BackgroundCheckService, BackgroundDashboardService, PDFService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    }
  ],
  entryComponents: [SuccessDialogComponent, EditEmployeeListDialogComponent,
    UploadFileDialogComponent, EditVerifierListDialogComponent, PackageListDialogComponent,
    PersonalPackageListDialogComponent, SelectedServiceDialogComponent, TurnAroundTimeDialogComponent,
    ImpressEmployerDialogComponent, ConfirmationAddServiceDialogComponent, ViewProgressDialogComponent,
    AddAddressComponent, SignatureDialogComponent, ViewMoreAddressDialogComponent, UserExistConfirmationDialogComponent, FeeApprovalModelComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
